import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--range-picker"
//
// Drives the period picker on the admin statistics pages. A preset submits
// the form right away. The custom choice reveals the two date fields instead,
// and the form only submits once both dates are filled - a half-picked range
// would otherwise reload the page and fall back to the default period. Hidden
// date fields are disabled so a preset does not drag empty dates into the URL.
export default class extends Controller {
  static targets = ["select", "dates", "date"]
  static values = { custom: String }

  change() {
    if (this.selectTarget.value === this.customValue) {
      this.datesTarget.classList.remove("hidden")
      this.dateTargets.forEach((input) => { input.disabled = false })
      if (this.datesFilled) this.submit()
      else this.dateTargets.find((input) => !input.value)?.focus()
    } else {
      this.datesTarget.classList.add("hidden")
      this.dateTargets.forEach((input) => { input.value = ""; input.disabled = true })
      this.submit()
    }
  }

  submit() {
    this.element.requestSubmit()
  }

  get datesFilled() {
    return this.dateTargets.every((input) => input.value)
  }
}
